import axios from 'axios'
import { ErrorWrapper } from '@utils/error-handler'
import { arrayToQueryString } from '@utils/url'
export const state = {
  categoryList: [],
  subCategoryList: [],
}

export const getters = {}

export const mutations = {
  CACHE_CATEGORY_LIST(state, newList) {
    state.categoryList = newList
  },
  CACHE_SUB_CATEGORY_LIST(state, newList) {
    state.subCategoryList = newList
  },
  CACHE_ALL_SUB_CATEGORY_LIST(state, newList) {
    state.allSubCategoryList = newList
  },
}

export const actions = {
  fetchCategoryList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/category?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data.docs
        commit('CACHE_CATEGORY_LIST', list)
        return list
      })
      .catch((error) => {
        return new ErrorWrapper(error)
      })
  },
  addCategory({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/category`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  updateCategory({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/category/${Data.id}`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  deleteCategory({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/category/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  fetchSubCategoryList({ commit, dispatch, rootState }, { category }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/subcategory/all`)
      .then((response) => {
        const list = response.data
        const finalList = list.filter((item) => {
          return item.category_id === category
        })
        commit('CACHE_SUB_CATEGORY_LIST', finalList)
        return list
      })
      .catch((error) => {
        return new ErrorWrapper(error)
      })
  },
  fetchAllSubCategoryList({ commit, dispatch, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/subcategory?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data.docs
        commit('CACHE_ALL_SUB_CATEGORY_LIST', list)
        return list
      })
      .catch((error) => {
        return new ErrorWrapper(error)
      })
  },
  addSubCategory({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/subcategory`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  updateSubCategory({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/subcategory/${Data.id}`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  deleteSubCategory({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/subcategory/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
